import {VXPay} from '../utils/VXPay';
import "../../../src/VX/Asset/Less/VX/View/Plain.less";

function onReadyHandler() {
	let buttons;

	buttons = document.querySelectorAll('.js-vxpay-signup-or-login');
	for (let i = 0; i < buttons.length; i++) {
		const $el = buttons[i];
		if (!$el.dataset['clickListener']) {
			$el.dataset['clickListener'] = 'true';
			$el.onclick                   = function(event) {
				if (event.preventDefault) {
					event.preventDefault();
				}
				VXPay.openSignupOrLogin();
			};
		}
	}

	buttons = document.querySelectorAll('.js-vxpay-settings');
	for (let i = 0; i < buttons.length; i++) {
		const $el = buttons[i];
		if (!$el.dataset['clickListener']) {
			$el.dataset['clickListener'] = 'true';
			$el.onclick                   = function(event) {
				if (event.preventDefault) {
					event.preventDefault();
				}
				VXPay.openSettings();
			};
		}
	}
}

function run() {
	const _onReady = onReadyHandler.bind(this);

	if (document.readyState !== 'loading') {
		_onReady();
	} else {
		window.addEventListener('DOMContentLoaded', _onReady, false);
	}
}

export {run};
